import { fetchWithAuth } from '../utils/fetchWithAuth';
import { unwrapResponse as unwrap } from '../utils/unwrapResponse';

export interface InvitationTarget {
  kind: 'user' | 'technician';
  id: number;
}

export type InvitationState = 'resendable' | 'link_valid' | 'inactive';

export interface InvitationStatus {
  state: InvitationState;
  expiresAt: string | null;
}

const STATES: readonly string[] = ['resendable', 'link_valid', 'inactive'];

const invitationPath = ({ kind, id }: InvitationTarget) =>
  kind === 'user' ? `users/${id}/invitation` : `admin/technicians/${id}/invitation`;

export const fetchInvitationStatus = async (target: InvitationTarget): Promise<InvitationStatus> => {
  const data = await unwrap<{ state?: string; expiresAt?: string | null }>(
    await fetchWithAuth(invitationPath(target)),
    'Failed to load the invitation status'
  );
  // An unexpected state falls back to resendable: the server re-checks on POST.
  const state = STATES.includes(data?.state ?? '') ? (data.state as InvitationState) : 'resendable';
  return { state, expiresAt: typeof data?.expiresAt === 'string' ? data.expiresAt : null };
};

export const resendInvitation = async (target: InvitationTarget): Promise<{ queued: boolean }> => {
  const data = await unwrap<{ queued?: boolean }>(
    await fetchWithAuth(invitationPath(target), { method: 'POST' }),
    'Failed to resend the invitation'
  );
  return { queued: data?.queued === true };
};
